
import React from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { motion } from 'framer-motion';
import { CloseButton } from './Buttons';
import { i18n } from '../i18n';
import {Bkg, Outline} from './Elements';

export const DarkPage = styled.div`
	box-sizing: border-box;
	position:absolute;
	top: 0;
	width: 100vw;
	height: 100dvh;
	display: flex;
	justify-content: center;
	align-items: center;
	pointer-events: auto;
	z-index: 3010;

	&:before {
		content: '';
		position:absolute;
		width: 100%; 
		top: calc(${p => !isNaN(p.top) ? p.top : 1} * var(--bar-height));
		height: calc(100dvh - ${p => !isNaN(p.top) ? p.top : 1} * var(--bar-height));
		@keyframes fadeIn {
			from: {background: rgba(0, 0, 0, 0)} to {background: rgba(0, 0, 0, 0.75)}
		}
		animation: fadeIn 1s forwards;
	}
`;

export const Content = styled(motion.div)`
	position: relative;
	text-align:center;
	width: 100%;
	//max-height: 100vh;
	height: ${p => p.h}vw;
	display:flex;
	flex-direction:column;	// 4044
	@media (min-aspect-ratio: 9/15) {
		transform: scale(0.7) !important;
	}
`;

export const Panel = styled(p => {
	return <motion.div className = {p.className}
		initial={{ y: '-100vh' }}
		exit={{
			y: '-100vh',
			transition: { type: 'tween', duration: 0.5 },
		}}
		animate={{ y: p.top ? p.top : '0'}}
		transition={{
			y: { type: 'spring', stiffness: 300, damping: 20, mass: 1.5, duration: 1 },
		}}
		onAnimationComplete={p.onAnimComplete}
	>
		<Bkg src={p.fullPath ? p.sprite : `assets/languages/${store.getLanguage}/${p.sprite}`}/>
		{p.children}
	</motion.div>
})`
	position: absolute;
	width: 90%;
	left:5%;
	height: ${p => p.h}vw;
	//background-image: url("/assets/languages/${p => store.getLanguage + '/' + p.sprite}");
	//background-size:cover;
`;

export const FixedText = styled.div`
	//border: 1px solid white;
	position: absolute;
	top: ${p => p.t}%;
	left: ${p => p.l}%;
	width: ${p => p.w}%;
	height: ${p => p.h}%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	text-shadow: 0 0.05em 0 rgb(0 0 0 / 40%);
    font-size: ${p => p.fs || 7}vw;
`;
export const PopupText = styled(Outline)`
	color: white;
	font-weight: ${p => p.fw || 600};
	width: 80%;
	font-size: ${p => p.fs || 4}vw;
	position: relative;
	white-space: pre-wrap;
`;

export const SimplePopup = styled(p => { 
	const prevent = e => e.stopPropagation()
	const closePopup = () => {
		store.onBackButton = store.skillzBackButtons.pop()[0];
		p.clickX();
	}
	if(p.clickX) {
		const last = store.skillzBackButtons.slice(-1)[0]
		if(p.backKey !== last[1]) {
			store.skillzBackButtons.push([store.onBackButton, p.backKey]);
			store.onBackButton = closePopup;
		}
	}

	return (
	<div className={p.className}>
		<DarkPage top={p.top ? p.top : 0}
			onClick={prevent}
			onMouseDown={prevent}
			onMouseUp={prevent}
			onTouchStart={prevent}
			onPointerUp={prevent}
			onPointerDown={prevent}
		>
			<Content h={p.totalH ? p.totalH : p.h}>
				<Panel h={p.h} sprite={p.box} fullPath={p.fullPath}>
					{p.title && <PopupTitle textKey={p.title} tfs={p.titleFS} tt={p.titleTop}/>}
					{p.clickX && <CloseButton onClick={closePopup} top={p.xTop} right={p.xRight} />}
					{p.children}
				</Panel>
			</Content>
		</DarkPage>
	</div>
)})`
	& ${Content} {
		top: calc(var(--bar-height) / 2);
	}
`;
const PopupTitle = styled(p => { return (
	<div className={p.className}>
		{i18n.t(p.textKey)}
	</div>
)})`
	font-size: ${p => p.tfs || '7'}vw;
	font-weight: 800;
	text-transform: uppercase;
	text-shadow: 0 0.1vw 0 #000000b3;
	white-space: nowrap;
	text-align: center;
    position: relative;
    top:  ${p => p.tt || '2.5'}vw;
    color: white;
    margin: 0 auto;
	//transform: scaleX(min(1, calc(13/${p => p.children.length})));
`;